module.exports = __webpack_public_path__ + "img/img_04.c7302eca.jpg";